// Story 1.21 — rendered when the latest application is `rejected` AND
// within the 30-day cooldown window. Tells the user why, shows when
// they can re-apply.

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@greenhold/components";

import type { CreatorApplicationStatus } from "./useCreatorApplicationStatus";

const COOLDOWN_DAYS = 30;

interface Props {
  application: CreatorApplicationStatus;
}

export function RejectedCooldownCard({ application }: Props) {
  const submitted = new Date(application.submitted_at);
  const cooldownEnd = new Date(
    submitted.getTime() + COOLDOWN_DAYS * 24 * 60 * 60 * 1000,
  );
  const now = new Date();
  const daysRemaining = Math.max(
    0,
    Math.ceil((cooldownEnd.getTime() - now.getTime()) / (24 * 60 * 60 * 1000)),
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Your previous application wasn't accepted</CardTitle>
        <CardDescription>
          You can re-apply in {daysRemaining} day{daysRemaining === 1 ? "" : "s"}{" "}
          ({cooldownEnd.toLocaleDateString()}).
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {application.rejection_reason && (
          <div>
            <p className="text-sm font-semibold opacity-70">Reason</p>
            <p className="leading-relaxed">{application.rejection_reason}</p>
          </div>
        )}
        <p className="text-sm opacity-70">
          The 30-day cooldown gives you time to address the feedback before
          re-applying. We review each application on its own merits.
        </p>
      </CardContent>
    </Card>
  );
}
